import { useMemo } from "react";

const R = 28;
const W = R * Math.sqrt(3);
const H = R * 1.5;

const hexPoints = (cx, cy, r) => Array.from({ length: 6 }, (_, i) => {
  const a = (Math.PI / 180) * (60 * i - 30);
  return `${(cx + r * Math.cos(a)).toFixed(1)},${(cy + r * Math.sin(a)).toFixed(1)}`;
}).join(" ");

export const HoneycombBackground = () => {
  const cells = useMemo(() => {
    let seed = 7;
    const rnd = () => ((seed = (seed * 9301 + 49297) % 233280) / 233280);
    return Array.from({ length: 70 }, () => {
      const row = Math.floor(rnd() * 34);
      const col = Math.floor(rnd() * 60);
      return { x: col * W + (row % 2 ? W / 2 : 0), y: row * H, d: (rnd() * 9).toFixed(2), t: (5 + rnd() * 6).toFixed(2), f: rnd() > 0.7 };
    });
  }, []);
  return (
    <div aria-hidden className="hc-bg pointer-events-none fixed inset-0 -z-10 overflow-hidden" data-testid="honeycomb-background">
      <svg className="absolute inset-0 h-full w-full">
        <defs>
          <pattern id="hc" width={W} height={H * 2} patternUnits="userSpaceOnUse">
            <polygon points={hexPoints(W / 2, R, R - 1)} fill="none" stroke="#39FF14" strokeOpacity="0.16" strokeWidth="1" />
            <polygon points={hexPoints(0, R + H, R - 1)} fill="none" stroke="#39FF14" strokeOpacity="0.16" strokeWidth="1" />
            <polygon points={hexPoints(W, R + H, R - 1)} fill="none" stroke="#39FF14" strokeOpacity="0.16" strokeWidth="1" />
          </pattern>
          <radialGradient id="hcfade" cx="50%" cy="30%" r="75%">
            <stop offset="0" stopColor="#fff" stopOpacity="1" />
            <stop offset="1" stopColor="#fff" stopOpacity="0.35" />
          </radialGradient>
          <mask id="hcmask"><rect width="100%" height="100%" fill="url(#hcfade)" /></mask>
        </defs>
        <g mask="url(#hcmask)">
          <rect width="100%" height="100%" fill="url(#hc)" />
          {cells.map((c, i) => (
            <polygon key={i} points={hexPoints(c.x + W / 2, c.y + R, R - 3)} className={c.f ? "hc-cell hc-cell-fill" : "hc-cell"}
              style={{ animationDelay: `${c.d}s`, animationDuration: `${c.t}s` }} />
          ))}
        </g>
      </svg>
      <img src="/brand/hive-bee-bg.png" alt="" data-testid="honeycomb-bee" className="hc-bee absolute left-1/2 top-1/2 w-[min(78vw,620px)] -translate-x-1/2 -translate-y-1/2 select-none" draggable={false} />
      <div className="hc-scan absolute inset-x-0 h-40" />
      <div className="absolute inset-0 bg-[radial-gradient(900px_420px_at_12%_-8%,rgba(57,255,20,0.18),transparent_60%),radial-gradient(700px_380px_at_95%_105%,rgba(57,255,20,0.13),transparent_60%)]" />
    </div>
  );
};
